export const DATA_VARIABLE = '?dat';
export const OBJECT_VARIABLE = '?obj';
